module.exports = __webpack_public_path__ + "img/daffodil-summarynextsteps.f753ad73.png";